/**
 * Accroches du visuel a partager (S64).
 *
 * Une phrase tiree au hasard a l'ouverture, en francais ou en creole, que le
 * producteur garde ou remplace. Le catalogue vit ICI et nulle part ailleurs :
 * en ajouter une = une ligne. Le serveur, lui, imprime ce qu'on lui envoie
 * (80 caracteres max, voir `MAX_ACCROCHE` cote backend).
 */
export const ACCROCHES = [
  // Francais
  'Venez faire le plein de bons produits, frais et bio',
  'Fraîchement cueilli ce matin, pour vous',
  'Le goût du pays, directement du jardin',
  'Cette semaine au marché : que du frais',
  'Du producteur à votre panier, sans détour',
  // Creole martiniquais
  'Vini pran bon pwodui fré é bio !',
  'Sa ki bon, sa ki fré, sé la !',
  'Fwi é légim péyi, kéyi jòdi-a',
  'An bel rékòt ka atann zot !',
  'Manjé péyi, manjé santé',
]

/** Sous-titre par defaut : la ligne « rendez-vous » sous l'accroche. */
export const SOUS_TITRE_DEFAUT = 'Au marché @manrina_mq samedi matin'

/** Une accroche au hasard, differente de `sauf` si possible. */
export function accrocheAleatoire(sauf) {
  const choix = ACCROCHES.filter((a) => a !== sauf)
  return choix[Math.floor(Math.random() * choix.length)]
}

/** Textes proposes pour le sticker rond ; la personne peut ecrire le sien ou le retirer. */
export const STICKERS = ['Direct producteur', '100% péyi', 'Frais du jour', 'Bio', 'Sans pesticide', 'Cueilli ce matin']
